import React from "react";

import { validPhone } from "./useMegawinPurchase";

export default function PhoneInput({ id, phone, setPhone }) {
  const invalid = phone.length > 0 && !validPhone(phone);
  return (
    <>
      <label htmlFor={id}>Утасны дугаар</label>
      <input
        id={id}
        className="megawin-phone"
        required
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        pattern="[0-9]{8}"
        value={phone}
        aria-describedby={`${id}-hint`}
        aria-invalid={invalid}
        onChange={(event) => setPhone(event.target.value)}
      />
      <p
        id={`${id}-hint`}
        className={invalid ? "megawin-checkout-error" : "megawin-checkout-note"}
      >
        {invalid
          ? "Утасны дугаар яг 8 цифрээс бүрдэх ёстой."
          : "Та өөрийн ашигладаг 8 оронтой утасны дугаарыг оруулна уу."}
      </p>
    </>
  );
}
